import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { AllMeetingMessageType } from 'mini-calendar-event-services/lib/schema/AllMeetingMessageType';

export const isCurrentUserTheMeetingOrganizer = (item: AllMeetingMessageType) => {
    if (item?.IsOrganizer) {
        return true;
    }
    const userEmailAddress = getUserConfiguration()?.SessionSettings?.UserEmailAddress;
    const organizer = item?.Organizer?.Mailbox?.EmailAddress;
    return !!userEmailAddress && !!organizer && userEmailAddress === organizer;
};
